import React, { Component } from 'react';
import ReactGridLayout from 'react-grid-layout';
import _ from 'lodash';
import styled from 'styled-components';

const ZoomComponent = styled.div`
    transform: scale(${({ scale }) => scale});
    transform-origin: left top;
    width: ${({ width }) => width}px;
    font-size: 12px;
    .react-resizable-handle {
        z-index: 2;
    }
`;

const pageHeight = 1550; // If you change this please test that the PDFs will still work
const pageWidth = 1079;
const rowsPerPage = 67;

export default class ConfiguredReactGridLayout extends Component {
    render() {
        const width = this.props.width || pageWidth;
        const scaleFactor = width / pageWidth;
        const rowHeight = pageHeight / rowsPerPage;
        // Find the bottom-most item in the layout, then get its y position, and add it to its height: this gives the total number of rows in the report

        const scaledWidth = document.body.clientWidth / scaleFactor;

        const args = Object.assign(
            {
                rowHeight,
                width: pageWidth,
                cols: 12,
                autoSize: false,
                compactType: null,
                containerPadding: [0, 0],
                margin: [0, 0],
                isDraggable: false,
                isResizable: false,
                useCSSTransforms: true,
                style: { height: '100%' },
            },
            _.omit(this.props, ['width', 'children'])
        );

        return (
            <ZoomComponent scale={scaleFactor} width={scaledWidth}>
                <ReactGridLayout {...args} transformScale={scaleFactor}>
                    {this.props.children}
                </ReactGridLayout>
            </ZoomComponent>
        );
    }
}
